import axios from 'axios';
import { ApiResponse, EquipState, zps_wp } from '../zps';

export type EquipDenomination = {
  amountRecycler: number;
  amountSafe: number;
  amountWC: number;
  cindex: number;
  qtyRecycler: number;
  qtySafe: number;
  qtyWC: number;
};

export type EquipCurrencyDenom = {
  cid: number; // currency id
  denominations: EquipDenomination[];
  totalAmount: number;
  totalAmountRecyclerCoins: number;
  totalAmountRecyclerBills: number;
  totalAmountSafeCoins: number;
  totalAmountSafeBills: number;
  totalQtySafeCoins: number;
  totalQtySafeBills: number;
  totalQtyRecyclerCoins: number;
  totalQtyRecyclerBills: number;
};

export type ProductDispenser = {
  entid: number;
  eid: number;
  dispenserid: number;
  productid: string;
  quantity: number;
  status: number;
  productName: string;
};

export type PeriodTotals = {
  cid: number;
  total: number;
  paid: number;
  paidAP: number;
};

export type EquipLocal = {
  entid: number;
  name: string;
  sid: number;
};

export type EquipPeriod = {
  gid: number;
  eid: number;
  period: number;
  dateTimeOpen: Date;
  dateTimeClose: Date;
  closeCode: number;
  totals: PeriodTotals[];
};

export interface IDashboardEquipmentV2 extends ApiResponse {
  eid: number;
  state: EquipState;
  entid: number;
  sn: string;
  description: string;
  equiType: number;
  local: EquipLocal;
  period?: EquipPeriod;
  existences?: EquipCurrencyDenom[];
  dispensers: ProductDispenser[];
}

export const fetchEquipmentDashboard2Info = (eid: number): Promise<IDashboardEquipmentV2> => {
  const url = `${zps_wp}/api/dashboard/equipment?eid=${eid}`;

  return axios.get<IDashboardEquipmentV2>(url).then(res => res.data);
};
